<template>
    <div class="flip-card" :class="back ? 'back' : ''">
        <div class="flip-card-inner">
            <div class="flip-card-front">
                <div class="card-wrapper">
                    <div class="card-number card-focusable" :class="{'focused':focused == 'card-number'}">{{ cardNumber || "0000 0000 0000 0000" }}</div>
                    <div class="card-holder card-focusable text-muted" :class="{'focused':focused == 'holder'}">{{ c_holder }}</div>
                    <div class="card-expire card-focusable" :class="{'focused':focused == 'expire'}">{{ c_expire }}</div>
                    <div class="card-icon" v-if="c_type">
                        <img :src="c_type == 'MASTERCARD' ? icons.mastercard : icons.visa" />
                    </div>
                </div>
            </div>
            <div class="flip-card-back">
                <div class="card-back-wrapper">
                    <div class="card-line">
                        <span class="mr-2 card-focusable" :class="{'focused':focused == 'cvc'}">{{ cvc || "####" }}</span>
                    </div>
                    <div class="card-icon" v-if="c_type">
                        <img :src="c_type == 'MASTERCARD' ? icons.mastercard : icons.visa" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        expireMonth:String,
        expireYear:String,
        holder:String,
        cardNumber:String,
        cvc:String,
    },
    data(){
        return {
            back:false,
            focused:null,
            focusable:['holder','card-number','expire','cvc'],
            icons:{
                mastercard:require('./icons/master.svg'),
                visa:require('./icons/visa.svg')
            }
        }
    },
    methods:{
        focus(type){
            if(this.focusable.includes(type)){
                this.focused = type
                if(type == 'cvc') this.back = true
                else this.back = false
            }else{
                this.focused = null
                this.back = false
            }
            
        }
    },
    computed:{
        c_expire(){
            return [this.expireMonth || 'AA', this.expireYear || 'YY'].join('/')
        },
        c_holder(){
            if(this.holder?.trim()){
                return this.holder
            }else return "Kart Sahibi"
        },
        c_type(){
            let visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$')
            let mastercard = new RegExp('^5[1-5][0-9]{14}$')
            let mastercard2 = new RegExp('^2[2-7][0-9]{14}$')

            let cc = this.cardNumber?.replace(/\s+/g, '')

            if (visa.test(cc)) return 'VISA'
            if (mastercard.test(cc) || mastercard2.test(cc))return 'MASTERCARD'
            return null
        }
    }
}
</script>

<style>
.flip-card {
    background-color: transparent;
    width: 280px;
    height: 173px;
    perspective: 1000px;
}

.flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 0.375rem;
    text-align: center;
    transition: transform 0.6s;
    transform-style: preserve-3d;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%)
}

.flip-card.back .flip-card-inner {
    transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.dark-layout .flip-card-front {
    background-color: #3b4253;
    border: 1px solid hsl(222, 17%, 38%)
}

.flip-card-front {
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(240,240,240);
    border-radius: 0.5rem;
}

.flip-card-back {
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(240,240,240);
    border-radius: 0.5rem;
    transform: rotateY(180deg);
}

.dark-layout .flip-card-front,
.dark-layout .flip-card-back{
    background-color: #3b4253;
    border: 1px solid hsl(222, 17%, 38%)
}

.card-wrapper{
    padding: 0.5rem;
    height: 100%;
    width:100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: flex-start;
    position: relative;
}

.card-wrapper .card-number{
    font-size: 1.3rem;
    font-weight: bolder;
}

.card-wrapper .card-holder{
    font-size: 1.1rem;
}

.card-back-wrapper{
    height: 100%;
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.card-back-wrapper .card-line{
    margin-top: 2rem;
    height: 2.5rem;
    width: 100%;
    background-color: rgb(220,220,220);
    display: flex;
    align-items: center;
    justify-content: end;
    font-weight: bolder;
    color: black;
}

.dark-layout .card-line{
    background-color: hsl(222, 17%, 48%)
}

.card-focusable{
    transition: all .2s linear;
    border-radius: 5px;
    padding: 0px 0.5rem;
}

.card-focusable.focused{
    color: var(--primary) !important;
    background-color: hsl(219, 65%, 94%)
}

.card-icon{
    position: absolute;
    right: 5px;
    bottom: 5px;
    height: 40px;
    width: auto;
}

.card-icon > img{
    height: 100%;
}
.card-back-wrapper .card-icon > img{
    filter: grayscale(100%);
}

.dark-layout .card-focusable.focused{
    background-color: rgb(255, 255, 255,0.2);
    color: white !important;
}
</style>